export default {
  namespaced: true,
  state: {
    modal: false,
    redirect: '',
  },
  getters: {
    modal: state => state.modal,
    redirect: state => state.redirect,
  },
  mutations: {
    modalMutate(state, data) {
      state.modal = data;
    },
    redirectMutate(state, data) {
      state.redirect = data;
    },
  },
  actions: {
    setModal(context, data) {
      context.commit('modalMutate', data);
    },
    setRedirect(context, data) {
      context.commit('redirectMutate', data);
    },
  },
};
